<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="套餐名称">
                <a-input v-model="queryParam.packageName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="套餐类型">
                <a-select placeholder="请选择" v-model="queryParam.packageType" style="width: 100%" allow-clear>
                  <a-select-option :key="item.id" v-for="item in packageType"> {{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="状态">
                <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option :value="0"> 禁用 </a-select-option>
                  <a-select-option :value="1"> 启用 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="24" v-if="advanced && userType == 0">
              <a-form-item label="企业">
                <a-input v-model="queryParam.tenantFirmName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced && userType == 1">
              <a-form-item label="经销商">
                <a-input v-model="queryParam.tenantName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col> -->
            <!-- <a-col :md="6" :sm="24">
              <a-form-item label="企业">
                <a-select
                  show-search
                  v-model="queryParam.tenantAgentId"
                  placeholder="请选择"
                  :default-active-first-option="false"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  @search="handleSearch"
                >
                  <a-select-option v-for="d in agentList" :key="d.id">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="经销商">
                <a-select
                  show-search
                  v-model="queryParam.tenantAgentId"
                  placeholder="请选择"
                  :default-active-first-option="false"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  @search="handleSearch"
                >
                  <a-select-option v-for="d in agentList" :key="d.id">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker
v-model="value"
format="YYYY-MM-DD"
:placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime" />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <template>
          <a-button
type="primary"
@click="$refs.CreateForm.handleAdd()"
            v-hasPermi="['edc3d11367c10d4dd99dddeaf314fcecc:0:c']">
            新增
          </a-button>
          <!-- <a-button
            type="primary"
            :disabled="single"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['abm-fix:dev:edit']"
          >
            <a-icon type="edit" />修改
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['abm-fix:dev:remove']">
            <a-icon type="delete" />删除
          </a-button> -->
          <a-button
type="primary"
@click="handleExport"
v-hasPermi="['f1cd1866042366980928047f4b501a4de:0:e']"
            :disabled="value.length ? false : true">
            导出
          </a-button>
        </template>
      </div>
      <CreateForm ref="CreateForm" @ok="getList"></CreateForm>
      <a-table
:loading="loading"
:size="tableSize"
rowKey="id"
:columns="columns"
:data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
:pagination="false">
        <span slot="coverImageUrl" slot-scope="text, record">
          <div v-viewer v-if="record.coverImageUrl">
            <img :src="$url + record.coverImageUrl" alt="" style="width: 50px; height: 50px" />
          </div>
        </span>
        <span slot="packageType" slot-scope="text, record">
          <span>{{ record.packageType | formStatus(packageType) }}</span>
        </span>
        <span slot="status" slot-scope="text, record">
          <span>{{ record.status ? '启用' : '禁用' }}</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDeletes(record, undefined)" v-hasPermi="['edc3d11367c10d4dd99dddeaf314fcecd:0:s']">
            {{ record.status == 0 ? '启用' : '禁用' }}
          </a>
          <a-divider type="vertical" v-hasPermi="['edc3d11367c10d4dd99dddeaf314fcecr:0:r']" />
          <a @click="handleDelete(record, undefined)" v-hasPermi="['edc3d11367c10d4dd99dddeaf314fcecr:0:r']">
            删除
          </a>

        </span>
      </a-table>
      <a-pagination
class="ant-table-pagination"
show-size-changer
show-quick-jumper
:current="queryParam.pageNum"
        :total="total"
:page-size="queryParam.pageSize"
:showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
@change="changeSize" />
    </a-card>
    <!-- <detail ref="vrDetail"></detail> -->
  </page-header-wrapper>
</template>
<script>
import { fetchLists, delObj, editStatus } from '@/api/VR/storagePackage'
import CreateForm from './modules/CreateForm.vue'
// import detail from './modules/details.vue'
import { listTenant } from '@/api/system/tenant'
import { tableMixin } from '@/store/table-mixin'
import parameter from '@/mixins/parameter' // 必须出现
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'Work',
  components: {
    // detail,
    CreateForm,
  },
  mixins: [tableMixin, parameter],
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    ...mapGetters(['userTentant', 'infoUser']),
  },
  data() {
    return {
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      value: [],
      // 高级搜索 展开/关闭
      advanced: false,
      loading: false,
      tableSize: 'default',
      tableBordered: true,
      selectedRowKeys: [],
      columns: [
        {
          title: '套餐名称',
          dataIndex: 'packageName',
          width: '120px',
          key: 'packageName',
        },
        {
          title: '套餐类型',
          width: '90px',
          dataIndex: 'packageType',
          scopedSlots: { customRender: 'packageType' },
          key: 'packageType',
        },
        {
          title: '套餐价格',
          dataIndex: 'price',
          width: '90px',
        },
        {
          title: '单价(元/GB)',
          dataIndex: 'unitPrice',
          width: '108px',
        },
        {
          title: '有效期(天)',
          dataIndex: 'validDays',
          width: '100px',
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '70px',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '套餐容量(MB)',
          dataIndex: 'capacity',
          width: '120px',
          key: 'capacity',
        },
        {
          title: '套餐描述',
          dataIndex: 'description',
          width: '120px',
          key: 'description',
        },

        // {
        //   title: '作品点赞数',
        //   dataIndex: 'likeCount',
        //   key: 'likeCount',
        // },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   width: 140,
        //   align: 'center',
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '100px',
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
    }
  },
  methods: {
    getList() {
      this.loading = true
      fetchLists(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    /** 启用禁用按钮操作 */
    handleDeletes(row) {
      var that = this
      // let ids = []
      // if (row.id) {
      //   ids = [row.id]
      // } else {
      //   ids = this.ids
      // }
      const text = row.status == 0 ? '是否确认启用此数据' : '是否确认禁用此数据'
      this.$confirm({
        title: text,
        onOk() {
          return editStatus({ id: row.id }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() { },
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() { },
      })
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'vr/storage/package/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
    onChangeTime(e) {
      this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
      this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    // handleSearch(value) {
    //   console.log(value, 'valuevalue')
    //   this.getAgent(value)
    // },
    // 查代理商和企业
    // getAgent(name, e) {
    //   listTenant({ pageNum: 1, pageSize: 100, type: e, name: name }).then((res) => {
    //     if (e == 1) {
    //       this.agentList = res.data.records
    //     }else{
    //       this.agentList = res.data.records
    //     }
    //     // console.log(this.agentList, '的点点滴滴this.agentListthis.agentList')
    //   })
    // },
   
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
  },
  created() {
    if (this.userType == 1) {
      this.columns.splice(1, 1)
    }
    if (this.userType == 2) {
      this.columns.splice(2, 1)
    }
    console.log(this.userType, 'userTypeuserType')
    // if(this.userType==0){

    // }
    this.getList()
  },
  mounted() { },
}
</script>
<style lang="scss" scoped></style>
